import { InputSwitch } from "primereact/inputswitch";
import React from "react";

const Switch = ({
  checked = false,
  handleOnChange = () => {},
  disabled = false,
}) => {
  return (
    <InputSwitch
      checked={checked}
      onChange={handleOnChange}
      disabled={disabled}
    />
  );
};

export default Switch;
